import { VFlow } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import React from 'react'

import { ListaRegulacaoFilter } from './components/ListaRegulacaoFilter'
import { ListaRegulcaoTable } from './components/ListaRegulacaoTable'

export const RegulacaoView = () => {
  return (
    <>
      <Breadcrumb title='Regulação' />
      <PageContent fluid type='transparent'>
        <VFlow vSpacing={0.5}>
          <ListaRegulacaoFilter />
          <ListaRegulcaoTable />
        </VFlow>
      </PageContent>
    </>
  )
}
